#licensing-options-wrapper {
  height: 100%;

  display: flex;
  flex-direction: column;

  padding: calc(var(--spacer) * 3) 0 calc(var(--spacer) * 3) calc(var(--spacer) * 3);

  #licensing-options-inner-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-right: calc(var(--spacer) * 4);
    overflow-y: auto;
  }
}

.bottom-buttons {
  width: 100%;

  margin-top: calc(var(--spacer) * 2);

  display: flex;
  align-items: center;

  gz-button {
    margin-right: calc(var(--spacer) * 2);
  }
}
